export default __webpack_public_path__ + "static/hand-b57c10cf0dc849bb5eafb7fe661d9871.png";